import Header from "@/app/multi-step/header";
import { Outlet } from "react-router-dom";

export default function MultiStepLayoutTwo() {
    return (
        <div className="min-h-screen bg-gradient-to-r from-[#136A8A] to-[#267871] @container">
            <Header />
            {<Outlet />}
        </div>
    );
}
